import { useAppSelector } from '#components/redux/hooks';
import { REDUCER_SUPPORT_MODAL_NAME } from '#baseSupportModal/constants';

const useSupportModalState = () => useAppSelector(
  (state) => state[REDUCER_SUPPORT_MODAL_NAME],
);

export { useSupportModalState };
